<template>
<div>
  <!-- 编辑分组弹出框 -->
  <el-dialog class='category-dialog' :title="category.id ? $t('actions.category.edit') : $t('actions.category.new')" size='small' :visible.sync="dialogVisible">
    <image-uploader v-model="category.cover" :title="$t('actions.category.cover')" v-on:click='openMediaImageDialog' class='cover-wrapper' />
    <div class='inputs'>
      <el-input :placeholder="$t('placeholder.category.name')" v-model='category.name'></el-input>
      <el-input type="textarea" :rows='4' resize='false' :placeholder="$t('placeholder.category.description')" v-model="category.description"></el-input>
      <div class='publicity'>
        <el-checkbox class='publicity' v-model="category.publicity">
          {{$t('actions.category.publicity')}}
          <a target="_blank" href="http://mp.weixin.qq.com/s/jXd74hGwEVlXEiGtPHW8cQ"><i class='ppj-icon-help-circled'></i></a>
        </el-checkbox>
      </div>
    </div>

    <div class='buttons' slot='footer'>
      <el-button type='danger' :plain="true" class='left' v-show="category.id" @click="removeGroup">{{$t('actions.category.remove')}}</el-button>
      <el-button type='text' v-on:click='close()'>{{$t('common.buttons.cancel')}}</el-button>
      <el-button type="primary" v-on:click='update()'>{{$t('common.buttons.ok')}}</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>
export default {
  data() {
    return {
      category: {
        id: null,
        cover: null,
        name: null,
        description: null,
        publicity: null
      },
      dialogVisible: false
    }
  },
  methods: {
    open(params) {
      let vm = this
      let id = Number(params.id)
      if (!isNaN(id)) {
        // vm.category = JSON.parse(JSON.stringify(vm.$store.state.categories.items.find(value => Number(value.id) === id)))
        vm.$store.dispatch('category/get', {
          id: id
        }).then(res => {
          vm.category = JSON.parse(JSON.stringify(res))
          // since return data has no cover but required on upload
          vm.$set(vm.category, 'cover', vm.category.cover_url)
        })
      }
      if (params.success) {
        vm.$data.success = params.success
      }

      vm.dialogVisible = true
    },
    openMediaImageDialog() {
      let vm = this
      // 编辑分组的dialog唤起外层的资源库dialog
      vm.$mediaImage({
        tag: 'thumbnail',
        success: function(mediaId) {
          vm.$set(vm.category, 'cover', mediaId)
        }
      })
    },
    update() {
      let vm = this
      vm.$store.dispatch('category/create_or_update', vm.category).then((id) => {
        if (typeof vm.$data.success === 'function') {
          vm.$data.success(id)
        }
        vm.close()
      })
    },
    close() {
      this.category = {
        id: null,
        cover: null,
        name: null,
        description: null,
        publicity: null
      }
      this.dialogVisible = false
    },
    removeGroup() {
      let vm = this

      // warning hint
      vm.$confirm(vm.$t('messagebox.category.delete.message'), vm.$t('messagebox.category.delete.title', {
        name: vm.category.name
      }), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(_ => {
        vm.$store.dispatch('category/destroy', vm.category.id).then(_ => {
          // close and go to '/'
          vm.close()
          vm.$router.push({
            path: '/'
          })
        })
      }).catch(_ => {})
    }
  }
}
</script>

<style lang='scss' scoped>
$cover-height: 140px;

.category-dialog {
    .cover-wrapper {
        float: left;
        width: $cover-height;
        height: $cover-height;
        overflow: hidden;
        border: $border-base;
        position: relative;

        .img {
            position: absolute;
            background-color: $color-white-base;
            &:first-of-type {
                z-index: 2;
            }
        }

        .cover-selector {
            position: absolute;
            opacity: 0;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
        }
    }

    .inputs {
        width: 100%;
        padding-left: $cover-height + 0.8 * $font-size-base;

        & > div {
            margin-bottom: 1em;
        }

        .publicity {
            text-align: right;
            padding: 0;

            .ppj-icon-help-circled {
                color: $color-info;
                &:hover {
                    color: darken($color-info, 20%);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// edit.dialog.vue?4a38fc9e